import { useState } from 'react'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'

const DialogConfirmation = ({
  onBack,
  onConfirm,
  isSubmitting = false,
  ...dialogProps
}: Omit<DialogProps, 'children'> & {
  isSubmitting?: boolean
  onBack?: () => void
  onConfirm: () => void
}) => {
  const [checked, setChecked] = useState([false, false, false])
  const isEnableConfirmButton = checked.every((item) => Boolean(item))

  const updateItemAtIndex = (index, newValue) => {
    const newItems = [...checked]
    newItems[index] = newValue
    setChecked(newItems)
  }

  return (
    <Dialog {...dialogProps}>
      <DialogOverlay />
      <DialogContent>
        <div className="p-6">
          <div className="mb-6">
            <Text variant="heading-md" className="mb-5">
              Saya menyatakan sudah:
            </Text>

            <Checkbox
              checked={checked[0]}
              onChange={(e) => updateItemAtIndex(0, e.target.checked)}
            >
              Menyelesaikan pendampingan
            </Checkbox>
            <Checkbox
              checked={checked[1]}
              onChange={(e) => updateItemAtIndex(1, e.target.checked)}
            >
              Mengisi dengan baik sehingga dapat membantu kelancaran Diskusi
              Tindak Lanjut bersama Tim Kinerja
            </Checkbox>
            <Checkbox
              checked={checked[2]}
              onChange={(e) => updateItemAtIndex(2, e.target.checked)}
            >
              Membuat jadwal Diskusi Tindak Lanjut bersama Tim Kinerja
            </Checkbox>
          </div>

          <div className="flex gap-3">
            <Button size="lg" color="white" onClick={onBack}>
              Kembali
            </Button>
            <Button
              size="lg"
              color="blue"
              onClick={onConfirm}
              isLoading={isSubmitting}
              disabled={!isEnableConfirmButton || isSubmitting}
            >
              Konfirmasi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogConfirmation
